import { useTranslation } from 'react-i18next';
import type { StepState, SurveyProcess } from '../../../api/surveyProcess';
import { stepFocus, stepLine } from '../processView';
import classes from './SurveyProcess.module.css';

const MARK: Partial<Record<StepState, string>> = { done: '✓', stopped: '!' };

/** The four steps, with what each came to. They only show where the team is, so they are not buttons */
export const ProcessSteps = ({ process }: { process: SurveyProcess }) => {
  const { t, i18n } = useTranslation();
  return (
    <ol className={classes.steps} aria-label={t('surveyProcess.title')}>
      {process.steps.map(({ step, state }, index) => {
        const title = t(`surveyProcess.steps.${step}`);
        const line = stepLine(process, step, state, i18n.language);
        const focus = stepFocus(process, step, state, t);
        return (
          <li
            key={step}
            className={classes.step}
            data-state={state}
            aria-current={state === 'current' || state === 'stopped' ? 'step' : undefined}
          >
            <span className={classes.stepDot} aria-hidden="true">
              {MARK[state] ?? index + 1}
            </span>
            <span className={`ds-label ${classes.stepTitle}`} data-size="sm" data-state={state} aria-hidden="true">
              {title}
            </span>
            {line && (
              <span className={`ds-paragraph ${classes.stepLine}`} data-size="xs" data-state={state}>
                {t(line.key, line.values)}
              </span>
            )}
            {focus && (
              <span className={`ds-paragraph ${classes.stepLine}`} data-size="xs" data-state={state}>
                {t(focus.key, focus.values)}
              </span>
            )}
            <span className="ds-sr-only">
              {t('surveyProcess.stepAria', {
                number: index + 1,
                title,
                state: t(`surveyProcess.states.${state}`).toLowerCase(),
              })}
            </span>
          </li>
        );
      })}
    </ol>
  );
};
